if (!customElements.get("td-lp-combined-free-gift")) {
  class TdLpCombinedFreeGift extends HTMLElement {
    constructor() {
      super();
      // Get all free gift elements (one per product whose free_gift metafield is set)
      this.freeGiftElements = this.querySelectorAll('[data-free-gift-parent-id]');
    }

    connectedCallback() {
      this.applyInitialVisibility();
      document.addEventListener('free-gift-update', (e) => this.handleFreeGiftUpdate(e));
    }

    /**
     * Set the correct visibility and active state on every gift block before any
     * user interaction. The picker's connectedCallback fires its initial
     * free-gift-update synchronously, before this widget's listener is attached,
     * so we have to seed the state ourselves by reading the picker's DOM.
     */
    applyInitialVisibility() {
      const activeOption = document.querySelector('[data-product-item-id].td-active');
      const activeProductId = activeOption ? activeOption.getAttribute('data-product-item-id') : null;

      // Detect initial purchase type from the picker's checked toggle.
      // Defaults to subscription (matches the picker's default and covers PDPs
      // without a subscription/one-time toggle).
      const checkedToggle = document.querySelector('.td-lpcp__toggle-input:checked');
      const isSubscription = !checkedToggle || checkedToggle.value === 'subscription';

      this.freeGiftElements.forEach(freeGift => {
        const blockProductId = freeGift.getAttribute('data-free-gift-parent-id');
        const isActiveProduct = activeProductId !== null && blockProductId === activeProductId;
        freeGift.style.display = isActiveProduct ? '' : 'none';
        freeGift.classList.toggle('td-gift-active', isActiveProduct && isSubscription);
      });
    }

    handleFreeGiftUpdate(event) {
      const { productId, purchaseType } = event.detail;

      // Find the currently active gift and the new matching gift
      const currentActive = this.querySelector('.td-gift-active');
      const newMatch = this.querySelector(`[data-free-gift-parent-id="${productId}"]`);
      const shouldShow = newMatch && purchaseType === 'subscription';

      // If swapping between two products that both have free gifts,
      // skip the animation to prevent layout shift / flash
      if (currentActive && shouldShow && currentActive !== newMatch) {
        currentActive.style.transition = 'none';
        newMatch.style.transition = 'none';
        currentActive.classList.remove('td-gift-active');
        newMatch.classList.add('td-gift-active');

        // Re-enable transitions after the swap
        requestAnimationFrame(() => {
          currentActive.style.transition = '';
          newMatch.style.transition = '';
        });
      }

      // Toggle display + active class for every block.
      // Only the active product's block is ever displayed; its td-gift-active class
      // controls the dim (one-time) vs bright (subscription) state.
      this.freeGiftElements.forEach(freeGift => {
        const blockProductId = freeGift.getAttribute('data-free-gift-parent-id');
        const isActiveProduct = blockProductId === productId;

        freeGift.style.display = isActiveProduct ? '' : 'none';
        freeGift.classList.toggle(
          'td-gift-active',
          isActiveProduct && purchaseType === 'subscription'
        );
      });
    }
  }

  customElements.define("td-lp-combined-free-gift", TdLpCombinedFreeGift);
}
